webpackJsonp([190535782983301],{

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "praesens"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "imperfectum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteram"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "es"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potes"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteras"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "est"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potest"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterat"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteramus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "estis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potestis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteratis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "sunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "possunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "erant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "poterant"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben",
	                _react2.default.createElement("br", null),
	                "ik kan"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was",
	                _react2.default.createElement("br", null),
	                "ik kon"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Bij de bovenstaande tijden is het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " eigenlijk hetzelfde als het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          ", maar dan met ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pos-"
	          ),
	          " of",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pot-"
	          ),
	          " ervoor."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "perfectum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fui"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potui"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuisti"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuisti"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuit"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuimus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuistis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuistis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerunt"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben geweest",
	                _react2.default.createElement("br", null),
	                "ik heb gekund"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Het perfectum is compleet regelmatig, zolang je weet dat ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "fu-"
	          ),
	          " de stam van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          " is en ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "potu-"
	          ),
	          " de stam van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " is."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "praesens"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "imperfectum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteram"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "es"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potes"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteras"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "est"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potest"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterat"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteramus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "estis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potestis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteratis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "sunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "possunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "erant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "poterant"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben",
	                _react2.default.createElement("br", null),
	                "ik kan"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was",
	                _react2.default.createElement("br", null),
	                "ik kon"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Bij de bovenstaande tijden is het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " eigenlijk hetzelfde als het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          ", maar dan met ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pos-"
	          ),
	          " of",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pot-"
	          ),
	          " ervoor."
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Verwar het imperfectum van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " niet met het plusquamperfectum. Bij het plusquamperfectum wordt de perfectumstam",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "potu-"
	          ),
	          " gebruikt!"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "perfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "plusquamperfectum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fui"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potui"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueram"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuisti"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuisti"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueras"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerat"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueramus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuistis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuistis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueratis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerant"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben geweest",
	                _react2.default.createElement("br", null),
	                "ik heb gekund"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was geweest",
	                _react2.default.createElement("br", null),
	                "ik had gekund"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "De bovenstaande tijden zijn compleet regelmatig, zolang je weet dat",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "fu-"
	          ),
	          " de stam van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          " is en ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "potu-"
	          ),
	          " de stam van",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " is."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "praesens"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "imperfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "futurum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "ero"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potero"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "es"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potes"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eris"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteris"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "est"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potest"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterit"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterimus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "estis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potestis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eritis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteritis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "sunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "possunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "erant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "poterant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "erunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "poterunt"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben",
	                _react2.default.createElement("br", null),
	                "ik kan"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was",
	                _react2.default.createElement("br", null),
	                "ik kon"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik zal zijn",
	                _react2.default.createElement("br", null),
	                "ik zal kunnen"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Bij de bovenstaande tijden is het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " eigenlijk hetzelfde als het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          ", maar dan met ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pos-"
	          ),
	          " of",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pot-"
	          ),
	          " ervoor."
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Verwar het imperfectum van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " niet met het plusquamperfectum. Bij het plusquamperfectum wordt de perfectumstam",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "potu-"
	          ),
	          " gebruikt!"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "perfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "plusquamperfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "futurum exactum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fui"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potui"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuero"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuero"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuisti"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuisti"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueris"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueris"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerit"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerimus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuistis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuistis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueritis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueritis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerint"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerint"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben geweest",
	                _react2.default.createElement("br", null),
	                "ik heb gekund"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was geweest",
	                _react2.default.createElement("br", null),
	                "ik had gekund"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik zal zijn geweest",
	                _react2.default.createElement("br", null),
	                " ik zal hebben gekund"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "De bovenstaande tijden zijn compleet regelmatig, zolang je weet dat",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "fu-"
	          ),
	          " de stam van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          " is en ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "potu-"
	          ),
	          " de stam van",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " is."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 6 },
	              "indicativus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "praesens"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "imperfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "futurum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "ero"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potero"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "es"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potes"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eris"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteris"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "est"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potest"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterit"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterimus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "estis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potestis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eritis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteritis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "sunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "possunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "erant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "poterant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "erunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "poterunt"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben",
	                _react2.default.createElement("br", null),
	                "ik kan"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was",
	                _react2.default.createElement("br", null),
	                "ik kon"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik zal zijn",
	                _react2.default.createElement("br", null),
	                "ik zal kunnen"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Bij de bovenstaande tijden is het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " eigenlijk hetzelfde als het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          ", maar dan met ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pos-"
	          ),
	          " of",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pot-"
	          ),
	          " ervoor."
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Verwar het imperfectum van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " niet met het plusquamperfectum. Bij het plusquamperfectum wordt de perfectumstam",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "potu-"
	          ),
	          " gebruikt!"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 6 },
	              "indicativus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "perfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "plusquamperfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "futurum exactum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fui"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potui"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuero"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuero"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuisti"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuisti"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueris"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueris"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerit"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerimus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuistis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuistis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueritis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueritis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerint"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerint"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben geweest",
	                _react2.default.createElement("br", null),
	                "ik heb gekund"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was geweest",
	                _react2.default.createElement("br", null),
	                "ik had gekund"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik zal zijn geweest",
	                _react2.default.createElement("br", null),
	                " ik zal hebben gekund"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "De bovenstaande tijden zijn compleet regelmatig, zolang je weet dat",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "fu-"
	          ),
	          " de stam van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          " is en ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "potu-"
	          ),
	          " de stam van",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " is."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "conjunctivus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "praesens"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sim"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possim"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possit"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "simus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possimus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sitis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possitis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "sint"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "possint"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben",
	                _react2.default.createElement("br", null),
	                "ik kan"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Bij het praesens is het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " weer hetzelfde als het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          ", maar dan met ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pos-"
	          ),
	          " of ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pot-"
	          ),
	          " ",
	          "ervoor."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "praesens"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "es"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potes"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "est"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potest"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possumus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "estis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potestis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "sunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "possunt"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik kan"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " is eigenlijk hetzelfde als het rijtje van",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          ", maar dan met ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pos-"
	          ),
	          " of ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pot-"
	          ),
	          " ervoor."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 6 },
	              "indicativus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "praesens"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "imperfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "futurum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possum"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "ero"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potero"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "es"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potes"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eris"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteris"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "est"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potest"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterit"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possumus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "erimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poterimus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "estis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potestis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "eritis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "poteritis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "sunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "possunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "erant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "poterant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "erunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "poterunt"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben",
	                _react2.default.createElement("br", null),
	                "ik kan"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was",
	                _react2.default.createElement("br", null),
	                "ik kon"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik zal zijn",
	                _react2.default.createElement("br", null),
	                "ik zal kunnen"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Bij de bovenstaande tijden is het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " eigenlijk hetzelfde als het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          ", maar dan met ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pos-"
	          ),
	          " of",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pot-"
	          ),
	          " ervoor."
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Verwar het imperfectum van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " niet met het plusquamperfectum. Bij het plusquamperfectum wordt de perfectumstam",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "potu-"
	          ),
	          " gebruikt!"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 6 },
	              "indicativus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "perfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "plusquamperfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "futurum exactum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fui"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potui"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueram"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuero"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuero"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuisti"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuisti"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueras"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueris"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueris"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerat"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerit"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueramus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerimus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuistis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuistis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueratis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueritis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueritis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerunt"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerant"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerint"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerint"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben geweest",
	                _react2.default.createElement("br", null),
	                "ik heb gekund"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was geweest",
	                _react2.default.createElement("br", null),
	                "ik had gekund"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik zal zijn geweest",
	                _react2.default.createElement("br", null),
	                " ik zal hebben gekund"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "De bovenstaande tijden zijn compleet regelmatig, zolang je weet dat",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "fu-"
	          ),
	          " de stam van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          " is en ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "potu-"
	          ),
	          " de stam van",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " is."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 4 },
	              "conjunctivus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "praesens"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "imperfectum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sim"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possim"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "essem"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possem"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "esses"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "posses"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "esset"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "posset"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "simus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "essemus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possemus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "sitis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possitis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "essetis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "possetis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "sint"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "possint"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "essent"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "possent"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben",
	                _react2.default.createElement("br", null),
	                "ik kan"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was",
	                _react2.default.createElement("br", null),
	                "ik kon"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Bij het praesens is het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " weer hetzelfde als het rijtje van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          ", maar dan met ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pos-"
	          ),
	          " of ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "pot-"
	          ),
	          " ",
	          "ervoor."
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Het imperfectum is steeds de infinitivus plus de persoonsuitgangen."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "table" },
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 4 },
	              "conjunctivus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", { className: "col bor-bot" }),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "perfectum"
	            ),
	            _react2.default.createElement(
	              "th",
	              { colSpan: 2 },
	              "plusquamperfectum"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerim"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerim"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuissem"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuissem"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueris"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueris"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuisses"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuisses"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "3e ev."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerit"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuisset"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuisset"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "1e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuerimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuerimus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuissemus"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuissemus"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col" },
	              "2e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fueritis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potueritis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "fuissetis"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "potuissetis"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              { className: "col bor-bot" },
	              "3e mv."
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuerint"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuerint"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "fuissent"
	            ),
	            _react2.default.createElement(
	              "td",
	              { className: "bor-bot" },
	              "potuissent"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement("th", null),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik ben geweest",
	                _react2.default.createElement("br", null),
	                "ik heb gekund"
	              )
	            ),
	            _react2.default.createElement(
	              "td",
	              { colSpan: 2 },
	              _react2.default.createElement(
	                "em",
	                null,
	                "ik was geweest",
	                _react2.default.createElement("br", null),
	                "ik had gekund"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "De bovenstaande tijden zijn compleet regelmatig, zolang je weet dat",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "fu-"
	          ),
	          " de stam van ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "esse"
	          ),
	          " is en ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "potu-"
	          ),
	          " de stam van",
	          " ",
	          _react2.default.createElement(
	            "b",
	            null,
	            "posse"
	          ),
	          " is."
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          _Letop2.default,
	          null,
	          "Het futurum exactum en het perfectum conjunctivus hebben (afgezien van de 1e persoon enkelvoud) dezelfde vormen. Je moet dus aan de hand van de context bepalen of het een futurum exactum of een perfectum conjunctivus is."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _essePosse = __webpack_require__(651);
	
	var _essePosse2 = _interopRequireDefault(_essePosse);
	
	var _essePosse3 = __webpack_require__(647);
	
	var _essePosse4 = _interopRequireDefault(_essePosse3);
	
	var _essePosse5 = __webpack_require__(648);
	
	var _essePosse6 = _interopRequireDefault(_essePosse5);
	
	var _essePosse7 = __webpack_require__(649);
	
	var _essePosse8 = _interopRequireDefault(_essePosse7);
	
	var _essePosse9 = __webpack_require__(650);
	
	var _essePosse10 = _interopRequireDefault(_essePosse9);
	
	var _essePosse11 = __webpack_require__(652);
	
	var _essePosse12 = _interopRequireDefault(_essePosse11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "9",
	  table: _essePosse2.default
	}, {
	  les: "10",
	  table: _essePosse4.default
	}, {
	  les: "11",
	  table: _essePosse6.default
	}, {
	  les: "29",
	  table: _essePosse8.default
	}, {
	  les: "43",
	  table: _essePosse10.default
	}, {
	  les: "44",
	  table: _essePosse12.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, { defaultChapter: "44", data: data, title: "Esse & posse" });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-esse-posse-js-851f432a8e100037f3b0.js